import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../api/axios_instance";
import LoadingModal from "../../layouts/LoadingModal";
import Select from "react-select";
import {
  decryptRequest,
  encryptRequest,
} from "../../utils/encryptdecryptrequest";
import { formatAmount } from "../../utils/format";
import { matchTypeOptions } from "../../utils/constant";

const CronsPanel = () => {
  const [cronList, setCronList] = useState([]);
  const [selectedCron, setSelectedCron] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const maxDate = new Date().toISOString().split("T")[0];
  const [summaryData, setSummaryData] = useState(null);
  const [reportList, setReportList] = useState([]);
  const [matchType, setMatchType] = useState(null);

  const isOracleLedgerCron =
    selectedCron?.label === "Oracle Payment IN/OUT Transactions";

  useEffect(() => {
    const fetchCrons = async () => {
      try {
        const res = await axios_instance({
          url: "/cronspanel/getAllCronsName",
          method: "GET",
        });
        const data = decryptRequest(res.data.resData);
        const options = data.result.map((cron) => ({
          value: cron.value,
          label: cron.label,
        }));
        setCronList(options);
      } catch (error) {
        toast.error("Failed to fetch crons.");
      }
    };

    fetchCrons();
  }, []);

  useEffect(() => {
    const fetchReportList = async () => {
      try {
        const res = await axios_instance({
          url: "/cronspanel/getCronReportList",
          method: "GET",
        });

        const data = decryptRequest(res.data.resData);
        let decrypted = data?.result;
        if (
          decrypted?.status === true &&
          Array.isArray(decrypted?.reportList)
        ) {
          setReportList(decrypted.reportList);
        } else {
          toast.dismiss();
          toast.error("Failed to load report list.");
          setReportList([]);
        }
      } catch (error) {
        toast.dismiss();
        toast.error("Error fetching report list.");
        setReportList([]);
      }
    };

    fetchReportList();
  }, []);

  const handleDownload = async () => {
    toast.dismiss();

    if (isOracleLedgerCron && !matchType) {
      toast.error("Please select Match Type.");
      return;
    }
    // Mandatory fields
    if (!selectedCron || !fromDate || !endDate) {
      toast.error("All fields are mandatory.");
      return;
    }

    const from = new Date(fromDate);
    const to = new Date(endDate);

    // Invalid date check
    if (isNaN(from.getTime()) || isNaN(to.getTime())) {
      toast.error("Invalid dates.");
      return;
    }

    // From should be <= To
    if (from > to) {
      toast.error("From Date cannot be after End Date.");
      return;
    }
    try {
      setShowLoadingModal(true);
      const payload = encryptRequest({
        cron_id: selectedCron.value,
        fromDate,
        endDate,
        matchType: isOracleLedgerCron ? matchType.value : null,
      });
      const response = await axios_instance({
        url: "/cronspanel/downloadReport",
        method: "POST",
        data: { reqData: payload },
      });
      const result = decryptRequest(response.data.resData);
      if (result.status === true) {
        toast.dismiss();

        // Extract and set amounts if available
        if (result.viewResponse) {
          const { releasedAmount, receivedAmount } = result.viewResponse;
          setSummaryData({ releasedAmount, receivedAmount });
        }
        if (result.downloadUrl) {
          window.open(result.downloadUrl);
          setSummaryData(null);
        }
        toast.success(result.message);
        setSelectedCron(null);
        setFromDate("");
        setEndDate("");
        setMatchType(null);
      } else {
        toast.dismiss();
        toast.error(result.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Download failed.");
    } finally {
      setShowLoadingModal(false);
    }
  };

  return (
    <>
      {showLoadingModal && <LoadingModal />}
      <Header
        isNavigationModal={showNavigationModal}
        closeNavigationModal={() => setShowNavigationModal(false)}
        openNavigationModal={() => setShowNavigationModal(true)}
      />
      <div className="container-fluid">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />

        <section className="right_wrapper">
          <div className="panel-white">
            <div className="grayFiltr-bg brdr-FB clearfix">
              <div className="col-md-12">
                <h3 className="list_title">CRONS PANEL</h3>
              </div>
            </div>

            <div className="filter_box filter-section-bx resource_box crons_box p-4">
              <div className="row align-items-end">
                {/* Select Cron */}
                <div className={isOracleLedgerCron ? "col-md-3" : "col-md-3"}>
                  <label>
                    Select Cron <span className="col-red">*</span>
                  </label>
                  <Select
                    options={cronList}
                    value={selectedCron}
                    onChange={(selected) => {
                      setSelectedCron(selected);
                      setMatchType(null);
                    }}
                    placeholder="Select a Cron"
                  />
                </div>

                {/* Match Type (only for Oracle Ledger Cron) */}
                {isOracleLedgerCron && (
                  <div className="col-md-2">
                    <label>
                      Select Match Type <span className="col-red">*</span>
                    </label>
                    <Select
                      options={matchTypeOptions}
                      value={matchType}
                      onChange={setMatchType}
                      placeholder="Select Match Type"
                    />
                  </div>
                )}

                {/* From Date */}
                <div className={isOracleLedgerCron ? "col-md-2" : "col-md-3"}>
                  <label>
                    {"From Disbursed Date"}
                    <span className="col-red">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    max={maxDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>

                {/* To Date */}
                <div className={isOracleLedgerCron ? "col-md-2" : "col-md-3"}>
                  <label>
                    {"To Disbursed Date"}
                    <span className="col-red">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    max={maxDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                {/* Buttons Section */}
                <div
                  className={
                    isOracleLedgerCron
                      ? "col-md-3 d-flex align-items-end justify-content-start"
                      : "col-md-3 d-flex align-items-end justify-content-start"
                  }
                  style={{ marginTop: "25px" }}
                >
                  <button
                    className="btn rc-btn_primary pad-L20 pad-R20 mar-R3"
                    style={{ minWidth: "150px" }}
                    onClick={handleDownload}
                  >
                    Download / View
                  </button>

                  <button
                    className="btn rc-btn_rset pad-L20 pad-R20"
                    style={{ minWidth: "100px" }}
                    onClick={() => {
                      setSelectedCron(null);
                      setMatchType(null);
                      setFromDate("");
                      setEndDate("");
                      setSummaryData(null);
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            {summaryData && (
              <div className="d-flex justify-content-center gap-5 mb-3 payment-summary-container">
                <div className="payment-summary-item text-center p-3 bg-white shadow rounded">
                  <div className="summary-label font-weight-bold mb-1">
                    Payment Received Amount
                  </div>
                  <div
                    className="summary-value received text-success"
                    style={{ fontSize: "22px" }}
                  >
                    <span className="fa fa-inr"></span>
                    {formatAmount(summaryData.receivedAmount)}
                  </div>
                </div>
                <div className="payment-summary-item text-center p-3 bg-white shadow rounded">
                  <div className="summary-label font-weight-bold mb-1">
                    Payment Released Amount
                  </div>
                  <div
                    className="summary-value released text-danger"
                    style={{ fontSize: "22px" }}
                  >
                    <span className="fa fa-inr"></span>
                    {formatAmount(summaryData.releasedAmount)}
                  </div>
                </div>
              </div>
            )}

            <div className="report-section bg-white p-4 rounded shadow-sm border">
              <h5 className="mb-4 font-weight-semibold text-primary">
                Cron Report Summary
              </h5>

              <div className="table-responsive">
                <table className="table table-hover table-bordered mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th>Cron Name</th>
                      <th>Financial Year</th>
                      <th className="text-center">Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportList.length > 0 ? (
                      reportList.map((report, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{report.cronName || "NA"}</td>
                          <td>{report.financialYear || "NA"}</td>
                          <td className="text-center">
                            {report.downloadUrl ? (
                              <a
                                href={report.downloadUrl}
                                className="btn btn-sm btn-outline-success"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fa fa-download mr-1" /> Download
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted">
                          No reports found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CronsPanel;
